<template>
  <div class="not-full">
    <!--Document-->
    <DocumentImageItem
      v-for="(document, name) in documents"
      :key="name"
      :name="name"
      class="document tn-1s"
      :document="document"
    ></DocumentImageItem>
  </div>
</template>

<script>
import DocumentImageItem from './DocumentImageItem'

export default {
  name: 'DocumentList.vue',
  components: {
    DocumentImageItem
  },
  props: {
    documents: {
      type: Object,
      default() { return {} }
    },
    terms: {
      type: Array,
      default() { return [] }
    }
  },
  data: function () { return {} },
  computed: {},
  created() {},
  destroyed() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.document {
  width: 100%;
  margin-top: 16px;
  background: white;
  transition: all;
  transition-duration: 500ms;
  box-shadow: 0px 8px 18px rgba(32, 35, 36, 0.08);

  &:hover {
    background: #EDF4FC;
  }
  &:last-child {
    margin-bottom: 16px;
  }
}
</style>
